<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getPeakSeason,
  add,
  getDetails,
  update,
  deleteItem,
	batchDel
} from "@/api/finance/peak";

import cTable from "@/base/common/index";
import { getAllClient } from "@/api/user/client";
import { getCountry } from "@/api/system/country";

export default {
  components: {
    cTable
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "from_country")
        item.options = (
          await getCountry({ allow_depart: 1 })
        ).data.payload.rows;
      if (item.key === "to_country")
        item.options = (
          await getCountry({ allow_arrive: 1 })
        ).data.payload.rows;
    });
  },
  data() {
    return {
      methods: {
        list: getPeakSeason,
        getCountry,
        getAllClient,
        add,
        getDetails,
        update,
        deleteItem,
				batchDel
      },
      config: {
        slot: "div"
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              console.log(row);
              let data = this.handleFilterData();
              let type = "add";
              if (row.id) {
                type = "update";
                data.id = row.id;
              }
              this.$page.handleRequestMethods(type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 800,
              draggable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "name cannot be empty",
                  trigger: "blur"
                }
              ],
              from_country: [
                {
                  required: true,
                  message: "from_country cannot be empty",
                  trigger: "change"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "to_country be empty",
                  trigger: "change"
                }
              ],
              currency: [
                {
                  required: true,
                  message: "currency cannot be empty",
                  trigger: "change"
                }
              ],
              price: [
                {
                  required: true,
                  type: "number",
                  message: "price cannot be empty",
                  trigger: "blur"
                }
              ],
              is_fixed: [
                {
                  required: true,
                  message: "is_fixed cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { client_id: 24 },
            { from_country: 24 },
            { to_country: 24 },
            { currency: 24 },
            { price: 24 },
            { is_fixed: 24 },
            { start_time: 24 },
            { end_time: 24 },
            { tag: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_id",
              component: "Select",
              placeholder: () => this.$t("enter") + this.$t("clientName"),
              options: [],
              config: {
                label: "account",
                value: "id"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getAllClient")
                  ).payload.rows;
                  field.options.unshift({ account: this.$t("public"), id: 0 });
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("from_country"),
              key: "from_country",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("from_country"),
              options: [],
              config: {
                label({ row }) {
                  return row.cn_title + "(" + row.code + ")";
                },
                value: "code"
              },
              default: "CN",
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry", {
                      allow_depart: 1
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("target_country"),
              options: [],
              config: {
                label({ row }) {
                  return row.cn_title + "(" + row.code + ")";
                },
                value: "code"
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry", {
                      allow_arrive: 1
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("currencyCode"),
              key: "currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("currencyCode"),
              options: [
                {
                  label: this.$t("to_rmb"),
                  value: "CNY"
                },
                {
                  label: this.$t("to_usd"),
                  value: "USD"
                }
              ],
              default: "CNY"
            },
            {
              name: () => this.$t("price_t"),
              key: "price",
              component: "InputNumber",
              bind: {
                step: 0.01,
                min: 0,
                style: {
                  width: "100%"
                }
              },
              default: 0
            },
            {
              name: () => this.$t("whether") + this.$t("fixed_fee"),
              key: "is_fixed",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: "YES" },
                { label: this.$t("NO"), value: "NO" }
              ],
              bind: {
                border: true
              },
              default: "NO"
            },
            {
              name: () => this.$t("start") + this.$t("time"),
              key: "start_time",
              placeholder: () =>
                this.$t("select") + this.$t("start") + this.$t("time"),
              component: "DatePicker",
              bind: {
                options: {
                  disabledDate() {
                    return false;
                  }
                }
              },
              methods: {
                "on-change"({ row }) {
                  row["start_time"] = this.$page.format.timeFormat(
                    row.start_time
                  );
                }
              }
            },
            {
              name: () => this.$t("end") + this.$t("time"),
              key: "end_time",
              placeholder: () =>
                this.$t("select") + this.$t("end") + this.$t("time"),
              component: "DatePicker",
              bind: {
                options: {
                  disabledDate() {
                    return false;
                  }
                }
              },
              methods: {
                "on-change"({ row }) {
                  let time = this.$page.format.timeFormat(row.end_time);
                  if (time.slice(-8) === "00:00:00") {
                    time = time.split(" ")[0] + " " + "23:59:59";
                    row["end_time"] = time;
                  }
                }
              }
            },
            {
              name: () => this.$t("tag"),
              key: "tag",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("tag")
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 3
              },
              placeholder: () => this.$t("enter") + this.$t("Remarks")
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            name: () => this.$t("from_country"),
            key: "from_country",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("from_country"),
            options: [],
            config: {
              label({ row }) {
                return row.cn_title + "(" + row.code + ")";
              },
              value: "code"
            }
          },
          {
            name: () => this.$t("target_country"),
            key: "to_country",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("target_country"),
            options: [],
            config: {
              label({ row }) {
                return row.cn_title + "(" + row.code + ")";
              },
              value: "code"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
						{
						  name: this.$t("delete"),
						  type: "delete",
						  fnName: "delete",
							bind: {
							  type: "error"
							},
							disabled() {
							  return !this.selectAll.length;
							},
						}
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open();
            },
						delete() {
							let ids = this.selectAll.map(t=>t.id)
						  this.$Modal.confirm({
						    title: this.$t("delete"),
						    width: 300,
						    content: this.$t("titleModal"),
						    onOk: () => {
						      this.handleRequestMethods("batchDel", {ids}).then(res => {
						        this.$Message["success"]({
						          background: true,
						          content: res.msg
						        });
						        this.getList();
						      });
						    }
						  });
						}
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "left",
          minWidth: 150
        },
        {
          name: () => this.$t("clientName"),
          key: "client_account",
          align: "left",
          minWidth: 100,
          methods: {
            render({ value }) {
              return !value ? this.$t("public") : value;
            }
          }
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          width: 80
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          width: 80
        },
        {
          name: () => this.$t("currencyCode"),
          key: "currency",
          width: 80
        },
        {
          name: () => this.$t("price_t"),
          key: "price",
          minWidth: 80
        },
        {
          name: () => this.$t("whether") + this.$t("fixed_fee"),
          key: "is_fixed",
          width: 120,
          methods: {
            render({ value }) {
              return value == 0 ? this.$t("NO") : this.$t("YES");
            }
          }
        },
        {
          name: () => this.$t("start") + this.$t("time"),
          key: "start_time",
          width: 150
        },
        {
          name: () => this.$t("end") + this.$t("time"),
          key: "end_time",
          width: 150
        },
        {
          name: () => this.$t("Tag"),
          key: "tag",
          minWidth: 80
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 120
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 120,
          fixed: "right",
          list: [
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              }
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete"
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").open(res.payload, function() {
                  this.setTitle(this.$t("update"));
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("deleteItem", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
